let initialState = {
    timeStamp: Date.now()
}

export default (state = initialState, action) => {
    switch (action.type) {
        case "UPDATE_TIMESTAMP": return {timeStamp: Date.now()}
        default: return state;
    }
};